import css from "../../commonMagneticStyle.less";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import ChatForm from "./ChatForm";
import ExplainChat from "./ExplainChat";

const [HbrChat, HbrWindow] = reactWrapper(["hbr-chat", "hbr-window"]);

const MiniChat = ({ onCloseChat, explainChat, miniState }) => {
    const { t } = useTranslation();
    
    const setInput = (input) => {
        explainChat(input);
    }

    const handleInitialFocus = (event) => {
        event.preventDefault();
        // Get a reference to the input text area
        // querySelector is used here, use any standard way to access refs in your framework of choice
        document.querySelector("#chatInputTextarea")?.setFocus();
    }

    const handleCloseClick = () => {
        onCloseChat(false);
    }

    return (
        <div className={css["assist-icon-drawer"]}>
            <HbrWindow size="500px" open={open} onHbr-initial-focus={handleInitialFocus}>
                <div slot="header" className="hbr-css__layout-row-xs hbr-css__chat-header">
                    <div className="hbr-css__text-heading-lg-bold">{t('cornerTitle')}</div>
                    <hbr-tag size="small" accent="var(--hbr-color-accent-h-weak)">{t('beta')}</hbr-tag>
                    <div className="hbr-css__layout-justify-self-end">
                        <div className="hbr-css__layout-row-3xs">
                            <hbr-tooltip content="Close" placement="bottom">
                                <hbr-button
                                    onClick={handleCloseClick}
                                    variant="text"
                                    size="small"
                                    sentiment="neutral"
                                >
                                    <hbr-icon name="x" sentiment="neutral" size="16px" />
                                </hbr-button>
                            </hbr-tooltip>
                        </div>
                    </div>
                </div>
                {/** Chat Panel - Main */}
                <HbrChat>
                    <div slot="chat-panel" className="hbr-css__chat-panel">
                        {miniState.showChatWindow && miniState?.thread && (
                            <ExplainChat
                                selectedThread={miniState.thread}
                                chatSessionId="chat-session-id"
                                dialogId="chat-dialog-id"
                            />
                        )}
                        {
                            miniState.spinner && (
                                <div>
                                    <div className="hbr-css__chat-messages">
                                        {
                                            <hbr-chat-message variant="assistant">
                                                {miniState.error
                                                    ? <div>{t('explainWidgetSomething')}</div>
                                                    : <div className="hbr-css__layout-row-xs">
                                                        <hbr-spinner size="small">
                                                            <hbr-icon slot="icon" name="loader-gradient" static-colors />
                                                        </hbr-spinner>
                                                        <div className="hbr-css__text-ai-sm-bold">
                                                            {t('explainWidgetChatLoading')}
                                                        </div>
                                                    </div>
                                                }
                                            </hbr-chat-message>
                                        }
                                    </div>
                                </div>
                            )
                        }
                        <ChatForm
                            setInput={setInput}
                            miniState={miniState}
                        />
                    </div>
                </HbrChat>
            </HbrWindow>
        </div>
    );
}

MiniChat.propTypes = {
    onCloseChat: PropTypes.func.isRequired,
    explainChat: PropTypes.func.isRequired,
    miniState: PropTypes.shape({
        spinner: PropTypes.bool,
        showChatWindow: PropTypes.bool,
        thread: PropTypes.object,
        error: PropTypes.string
    }).isRequired
};
export default MiniChat;
